import { EvidenceForSector } from "../../api/models/Dashboard";
import { ragToBgClassMap, ragToRgb } from "../../constants";
import EvidenceRagChip from "./EvidenceRagChip";
import GridTable from "./GridTable";
import HorizontalBar from "./HorizontalBar";

export type BySectorEvidenceProps = {
    emissionsSourceEvidenceBySector: EvidenceForSector[];
};

const BySectorEvidence = ({
    emissionsSourceEvidenceBySector,
}: BySectorEvidenceProps) => {
    const data = emissionsSourceEvidenceBySector.map((_) => ({
        id: _.sectorId,
        name: _.sectorName,
        redCount: _.missingCount,
        amberCount: _.expiringIn30DaysCount,
        greenCount: _.inDateCount,
        color:
            _.missingCount > 0
                ? ragToRgb.red
                : _.expiringIn30DaysCount > 0
                ? ragToRgb.amber
                : ragToRgb.green,
    }));

    const ragTotalMax = Math.max(
        ...data.map((_) => _.redCount + _.amberCount + _.greenCount)
    );

    return (
        <div className="flex lg:space-x-6 items-center">
            <GridTable
                gridTemplateColumns="1fr 1fr 150px"
                data={data}
                headings={[
                    { label: "Sector" },
                    { label: "RAG count" },
                    { label: "Overall status" },
                ]}
                renderRow={(rowData) => (
                    <>
                        <div className="px-4 py-3 whitespace-nowrap overflow-hidden text-ellipsis">
                            {rowData.name}
                        </div>
                        {rowData.redCount +
                            rowData.amberCount +
                            rowData.greenCount >
                        0 ? (
                            <HorizontalBar
                                data={[
                                    {
                                        value: rowData.redCount,
                                        color: ragToBgClassMap["red"],
                                    },
                                    {
                                        value: rowData.amberCount,
                                        color: ragToBgClassMap["amber"],
                                    },
                                    {
                                        value: rowData.greenCount,
                                        color: ragToBgClassMap["green"],
                                    },
                                ]}
                                total={ragTotalMax}
                            />
                        ) : (
                            <p className="text-gray-400">No data</p>
                        )}
                        <div className="px-4 py-2">
                            <EvidenceRagChip
                                red={rowData.redCount}
                                amber={rowData.amberCount}
                            />
                        </div>
                    </>
                )}
            />
        </div>
    );
};

export default BySectorEvidence;
